import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

class ConfirmActionModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="modal fade" id={this.props.name ? this.props.name : "confirmActionModal"} tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Подтверждение</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Выполнить запрошенное действие?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Отмена</button>
                            <button type="button" className="btn btn-primary-custom" onClick={this.props.onConfirm} data-dismiss="modal">ОК</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmActionModal;